// Fenêtre de maintenance du démarrage zéro : état partagé par tous les écrans.
// Les saisies sont gelées côté serveur ; ce module informe l'interface et porte le
// jeton de jeu de données qui empêche un poste périmé de republier ses données.
const API = `${process.env.REACT_APP_BACKEND_URL}/api/demarrage`;
const CLE_EPOCH = 'erp.demarrage.epoch';

export let etatDemarrage = {
  maintenance: false, verrou: false, etape: 'normal', epoch: '', message: null,
  motif: '', depuis: null, date_depart: '', charge: false, renouvele: false,
};

let ecouteurs = [];
export const surDemarrage = (fn) => {
  ecouteurs.push(fn);
  fn(etatDemarrage);
  return () => {
    ecouteurs = ecouteurs.filter((f) => f !== fn);
  };
};
const annoncer = () => ecouteurs.forEach((f) => f(etatDemarrage));

export const epochActuel = () => localStorage.getItem(CLE_EPOCH) ?? '';
export const accepterEpoch = (epoch) => {
  if (epoch) localStorage.setItem(CLE_EPOCH, epoch);
};
export const ecrituresFermees = () => etatDemarrage.maintenance || etatDemarrage.verrou;

// Appelé avant chaque hydratation : l'interface connaît l'état AVANT toute saisie.
export async function chargerEtatDemarrage() {
  try {
    const r = await fetch(`${API}/etat`);
    if (!r.ok) return etatDemarrage;
    const etat = await r.json();
    const renouvele = Boolean(etat.epoch) && etat.epoch !== epochActuel();
    etatDemarrage = { ...etatDemarrage, ...etat, charge: true, renouvele };
    annoncer();
    return etatDemarrage;
  } catch (e) {
    return etatDemarrage;
  }
}

const json = async (chemin, options) => {
  const r = await fetch(`${API}${chemin}`, options);
  const corps = await r.json().catch(() => ({}));
  if (!r.ok) throw new Error(typeof corps.detail === 'string' ? corps.detail : `Erreur ${r.status}`);
  return corps;
};
const poster = (chemin, corps) =>
  json(chemin, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(corps) });

export const lireCouverture = () => json('/couverture');
export const ecarterSentinelle = (ident, motif) => poster(`/sentinelles/${encodeURIComponent(ident)}/ecarter`, { motif });
export const lireInventaire = () => json('/inventaire');
export const lireSauvegardes = () => json('/sauvegardes');
export const lireJournal = () => json('/journal');
export const basculerMaintenance = (actif, confirmation, motif) =>
  poster('/maintenance', { actif, confirmation, motif }).then((etat) => {
    etatDemarrage = { ...etatDemarrage, ...etat, charge: true };
    annoncer();
    return etat;
  });
export const leverVerrou = (confirmation, motif) => poster('/verrou/lever', { actif: false, confirmation, motif });
export const creerSauvegardeIntegrale = () => poster('/sauvegardes', {});
export const lancerNettoyage = (corps) => poster('/nettoyage', corps);
export const lancerRestauration = (corps) => poster('/restauration', corps);

export async function telechargerSauvegarde(ident) {
  const r = await fetch(`${API}/sauvegardes/${ident}/telecharger`);
  if (!r.ok) throw new Error('Téléchargement impossible.');
  const blob = await r.blob();
  const url = URL.createObjectURL(blob);
  const lien = document.createElement('a');
  lien.href = url;
  lien.download = `${ident}.json.gz`;
  document.body.appendChild(lien);
  lien.click();
  lien.remove();
  URL.revokeObjectURL(url);
  return r.headers.get('X-Empreinte-SHA256') || '';
}
